import cx from 'classnames2';

import React from 'react';

import { Icon } from '@opengov/component-library/capital/Icon';

import styles from './VisualizationSelect.scss';

export interface IVisualizationOptionProps {
  className?: string;
  isDisabled?: boolean;
  isFocused?: boolean;
  isSelected?: boolean;
  onFocus?: any;
  onSelect?: any;
  option: {
    icon: string;
    isCapitalIcon: boolean;
    name: string;
  };
  children?: React.ReactNode;
}

const getCapitalIcons = (iconName: string) => {
  const iconClassName = cx(iconName, styles['visualization-select-icon']);
  switch (iconName) {
    case 'graphtype-bullet':
      return <Icon icon="chart-bullet" className={iconClassName} />;
    case 'graphtype-percentBar':
      return <Icon icon="chart-percentbar" className={iconClassName} />;
    case 'graphtype-bar':
      return <Icon icon="chart-bar" className={iconClassName} />;
    case 'graphtype-horizontalbar':
      return <Icon icon="chart-horizontalbar" className={iconClassName} />;
    case 'graphtype-gauge':
      return <Icon icon="chart-gauge" className={iconClassName} />;
    default:
    case 'graphtype-line':
      return <Icon icon="chart-line" className={iconClassName} />;
  }
};

const renderIcon = (iconName: string, isCapitalIcon: boolean) => {
  const ovidIcon = <span className={cx(iconName, styles['visualization-select-icon'])} />;
  return isCapitalIcon ? getCapitalIcons(iconName) : ovidIcon;
};

export class VisualizationOption extends React.Component<IVisualizationOptionProps> {
  handleMouseDown = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    this.props.onSelect(this.props.option, event);
  };

  handleMouseEnter = (event: React.MouseEvent<HTMLDivElement>) => {
    this.props.onFocus(this.props.option, event);
  };

  handleMouseMove = (event: React.MouseEvent<HTMLDivElement>) => {
    if (this.props.isFocused) return;
    this.props.onFocus(this.props.option, event);
  };

  render() {
    return (
      <div
        className={cx(this.props.className, styles['visualization-select-option'])}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseMove={this.handleMouseMove}
        aria-selected="false"
        role="option"
      >
        {renderIcon(this.props.option.icon, this.props.option.isCapitalIcon)}
        {this.props.children}
      </div>
    );
  }
}

export interface IVisualizationValueProps {
  placeholder: string | React.ReactNode;
  value: {
    icon: string;
    isCapitalIcon: boolean;
    name: string;
  };
  children?: React.ReactNode;
}

export const VisualizationValue: React.FC<IVisualizationValueProps> = props => {
  const visualizationValueStyle = {
    color: '#3192c7'
  };

  return (
    <div className={cx('Select-value', styles['visualization-selected-value'])} title={props.value.name}>
      <span className="Select-value-label" style={visualizationValueStyle}>
        {renderIcon(props.value.icon, props.value.isCapitalIcon)}
        {props.children}
      </span>
    </div>
  );
};
